import React, { useEffect, useState } from 'react'
import request from '@/modules/base/util/request'
import SettingSection from './components/setting-section'
import TextBlock from '@/modules/base/components/texts/text-block'
import SettingsRadioInput from '@/modules/base/components/settings-radio-input/settings-radio-input'
import lang from '@/lang'
import PropTypes from 'prop-types'
import settingsConfig from '@/modules/settings/config'
import { useAccountSettings } from '@/modules/settings/components/tax-settings/services/account-setting-provider'

import { toast } from '@/modules/base/components/toast/toastConfig'
import useClientSetting from '@/modules/client/_helpers/useClientSetting'
import useCheckAccessRights from '@/modules/_helpers/accessCheck/useCheckAccessRights'
import { USER_RIGHTS, ROLES } from '@/modules/base/util/constants'
import { useSelector } from 'react-redux'

const SELECTABLE_TYPES = {
  netto: 'net',
  brutto: 'gross',
}

const options = [
  { value: SELECTABLE_TYPES.netto, title: 'Netto', description: lang.settings.taxes.grossNetSwitch.netDescription },
  { value: SELECTABLE_TYPES.brutto, title: 'Brutto', description: lang.settings.taxes.grossNetSwitch.grossDescription },
]

const GrossNetSwitch = () => {
  const [selectedOption, setSelectedOption] = useState()
  const { client, isClientSetting } = useClientSetting()
  const userInfo = useSelector(state => state.user.info)

  const isTaxConsultant = userInfo?.roles?.includes(ROLES.TAX_CONSULTANT_ROLE)
  const readOnly = isClientSetting ? false : isTaxConsultant || !useCheckAccessRights(USER_RIGHTS.SETTINGS.WRITE)
  const [isGross, setIsGross] = useState(false)
  const [initLoadDone, setInitLoadDone] = useState(false)
  const headers = {}
  if (isClientSetting) headers['collaboration-id'] = client?.id

  const getUseNetAsDefault = () => request(settingsConfig.account, { auth: true, isConcurrent: true, headers })
    .then(({ body: { data: { useNetAsDefault } } }) => {
      setIsGross(!useNetAsDefault)
    })
    .catch((error) => console.error({ error }))
    .finally(() => setInitLoadDone(true))

  useEffect(() => {
    getUseNetAsDefault()
  }, [])

  useEffect(() => {
    setSelectedOption(isGross ? SELECTABLE_TYPES.brutto : SELECTABLE_TYPES.netto)
  }, [isGross])

  const settingsUpdate = useAccountSettings()
  const handleOptionChange = (value) => {
    setSelectedOption(value)
    settingsUpdate
      .update({ useNetAsDefault: value === SELECTABLE_TYPES.netto })
      .then(() => toast.showToast({ message: lang.accountTaxSuccessMessage.default }))
  }

  const optionEls = options.map((option, index) => {
    const { value } = option
    const checked = selectedOption === value
    return (
      <SettingsRadioInput key={index} {...option} checked={checked} onChange={handleOptionChange} readOnly={readOnly} />
    )
  })
  return (
    initLoadDone
      ? (
        <SettingSection title={lang.settings.taxes.grossNetSwitch.title}>
          <TextBlock>{lang.settings.taxes.grossNetSwitch.grossNetSwitchTaxLabel}</TextBlock>
          <div>
            {optionEls}
          </div>
        </SettingSection>
      )
      : null
  )
}

GrossNetSwitch.propTypes = {
  isGross: PropTypes.bool,
}

GrossNetSwitch.defaultProps = {
  isGross: true,
  readOnly: false,
}

export default GrossNetSwitch
